<template>
    <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div>
            <!-- Sidebar navigation-->
            <nav class="sidebar-nav scroll-sidebar container-fluid">
                <ul id="sidebarnav">
                    <li class="sidebar-item" v-if="user.role === 1">
                        <div class="sidebar-link has-arrow" @click="option = option == 1 ? -1 : 1">
                            <span>
                                <i class="ti ti-home-2"></i>
                            </span>
                            <span class="hide-menu">Usuarios</span>
                        </div>
                        <ul aria-expanded="false" class="collapse first-level" :class="{ 'show' : option == 1}">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'Administratores' }" class="sidebar-link">
                                    <i class="ti ti-users"></i>
                                    <span class="hide-menu">Administradores</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'Customers' }" class="sidebar-link">
                                    <i class="ti ti-users"></i>
                                    <span class="hide-menu">Clientes</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'Guia' }" class="sidebar-link">
                                    <i class="ti ti-users"></i>
                                    <span class="hide-menu">Guia</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="user.role === 1">
                        <router-link class="sidebar-link sidebar-link" :to="{ name: 'Categories' }">
                            <span class="rounded-3">
                                <i class="ti ti-archive"></i>
                            </span>
                            <span class="hide-menu">Categorías</span>
                        </router-link>
                    </li>
                    <li class="sidebar-item" v-if="user.role === 1">
                        <router-link class="sidebar-link sidebar-link" :to="{ name: 'Schedules' }">
                            <span class="rounded-3">
                                <i class="ti ti-archive"></i>
                            </span>
                            <span class="hide-menu">Horarios</span>
                        </router-link>
                    </li>
                    <li class="sidebar-item" v-if="user.role === 1">
                        <router-link class="sidebar-link sidebar-link" :to="{ name: 'DisableDates' }">
                            <span class="rounded-3">
                                <i class="ti ti-settings"></i>
                            </span>
                            <span class="hide-menu">Fechas no hábiles</span>
                        </router-link>
                    </li>
                    <li class="sidebar-item">
                        <router-link class="sidebar-link sidebar-link" :to="{ name: 'MyAppointments' }">
                            <span class="rounded-3">
                                <i class="ti ti-archive"></i>
                            </span>
                            <span class="hide-menu">Mis citas</span>
                        </router-link>
                    </li>
                    <li class="sidebar-item" v-if="user.role === 1 || user.role == 2">
                        <div class="sidebar-link has-arrow" @click="option = option == 2 ? -1 : 2">
                            <span>
                                <i class="ti ti-home-2"></i>
                            </span>
                            <span class="hide-menu">Citas</span>
                        </div>
                        <ul aria-expanded="false" class="collapse first-level" :class="{ 'show' : option == 2}">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'Calendar' }" class="sidebar-link">
                                    <i class="ti ti-calendar"></i>
                                    <span class="hide-menu">Calendario</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'Home', query: { add: true } }" class="sidebar-link">
                                    <i class="ti ti-plus"></i>
                                    <span class="hide-menu">Agregar evento</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="user.role === 1">
                        <router-link class="sidebar-link sidebar-link" :to="{ name: 'Config' }">
                            <span class="rounded-3">
                                <i class="ti ti-settings"></i>
                            </span>
                            <span class="hide-menu">Configuración de sistema</span>
                        </router-link>
                    </li>
                </ul>
            </nav>
            <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
        <!-- <div class="fixed-profile p-3 bg-light-secondary rounded sidebar-ad mt-3 mx-9 d-block d-lg-none">
            <div class="hstack gap-3 justify-content-between">
                <div class="john-img">
                    <img src="@/assets/images/profile/user-1.jpg" class="rounded-circle" width="42" height="42" alt="">
                </div>
                <div class="john-title">
                    <h6 class="mb-0 fs-4">John Doe</h6>
                    <span class="fs-2">Designer</span>
                </div>
                <button class="border-0 bg-transparent text-primary ms-2" tabindex="0" type="button" aria-label="logout"
                    data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="logout">
                    <i class="ti ti-power fs-6"></i>
                </button>
            </div>
        </div> -->
    </aside>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      option: -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/partials/AppSidebar.vue